module.exports = __webpack_public_path__ + "img/smw-library03.4b899902.jpg";